export default __webpack_public_path__ + "static/assets/b48dd01130cec0b7f91f32e41677dd1c.png";